/**
 * Provides text/value options for the application.
 * Maps `text` to application text and `value` to AGRC values.
 */

/**
 * Returns options for supporting documents.
 * @param {*} text Application text
 * @returns Array of text/value options
 */
export const documentOptions = text => {
    const options = [
        {
            text : text.photos,
            value: 'PHTS',
        },
        {
            text : text.schoolCalendars,
            value: 'SCHCL',
        },
        {
            text : text.businessLicense,
            value: 'BLSAMWP',
        },
        {
            text : text.employersAnswer,
            value: 'EACF',
        },
        {
            text : text.jobDescriptions,
            value: 'JBDESC',
        },
        {
            text : text.authorizationForms,
            value: 'PSAF',
        },
        {
            text : text.proofOfAge,
            value: 'PRFAGE',
        },
        {
            text : text.letters,
            value: 'LTTRS',
        },
        {
            text : text.variances,
            value: 'VARNC',
        },
        {
            text : text.learningAgreements,
            value: 'WRLRAG',
        },
        {
            text : text.hoursExemption,
            value: 'HRSWED',
        },
        {
            text : text.extraDocuments,
            value: 'EXTRDCS',
        },
        {
            text : text.auditSpreadsheets,
            value: 'ADTSPRD',
        },
        {
            text : text.violationTotals,
            value: 'VLNTTLS',
        },
        {
            text : text.employerAppeal,
            value: 'EMPAPPL',
        },
        {
            text : text.paystubs,
            value: 'PAYTBS',
        },
        {
            text : text.timeCards,
            value: 'TIMCRDS',
        },
        {
            text : text.communication,
            value: 'CMNTXTEML',
        },
    ].sort((a, b) => a.text.localeCompare(b.text));

    // Add "Other" to the end of alphabetized list
    const otherOption = {
        text : text.other,
        value: 'OTHR',
    };
    options.push(otherOption);

    return options;
};

/**
 * Returns options for preferred language.
 * @param {*} text Application text
 * @returns Array of text/value options
 */
export const languageOptions = text => [
    {
        text : text.english,
        value: 'en',
    },
    {
        text : text.spanish,
        value: 'es',
    },
    {
        text : text.cambodian,
        value: 'COB',
    },
    {
        text : text.chineseSimplified,
        value: 'zh-cn',
    },
    {
        text : text.chineseTraditional,
        value: 'zh-tw',
    },
    {
        text : text.korean,
        value: 'ko',
    },
    {
        text : text.vietnamese,
        value: 'vi',
    },
    {
        text : text.russian,
        value: 'rus',
    },
    {
        text : text.somali,
        value: 'som',
    },
    {
        text : text.other,
        value: 'OTHLG',
    },
];

/**
 * Returns options for the preliminary question.
 * @param {*} text Application text
 * @returns Array of text/value options
 */
export const preliminaryOptions = text => [
    {
        text : text.yes,
        value: 'CLCMPQS2RYES',
    },
    {
        text : text.no,
        value: 'CLCMPQS2RNO',
    },
];

/**
 * Returns options for the list of termination reasons.
 * @param {*} text Application text
 * @returns Array of text/value options
 */
export const terminationOptions = text => [
    {
        text : text.quit,
        value: 'CLCMPQRESL3',
    },
    {
        text : text.fired,
        value: 'CLCMPQRESL4',
    },
    {
        text : text.laidOff,
        value: 'CLCMPQRESL2',
    },
    {
        text : text.idk,
        value: 'CLCMPQRESL1',
    },
    {
        text : text.other,
        value: 'CLCMPQRESL5',
    },
];

/**
 * Returns options for the list of violations.
 * @param {*} text Application text
 * @returns Array of text/value options
 */
export const violationOptions = text => [
    {
        text : text.underage,
        value: 'TEHMWUAG',
    },
    {
        text : text.records,
        value: 'TEKPRHM',
    },
    {
        text : text.breaks,
        value: 'TEDNPAB',
    },
    {
        text : text.permit,
        value: 'TEDMWPEBL',
    },
    {
        text : text.hours,
        value: 'TMWHOWAL',
    },
    {
        text : text.duties,
        value: 'TMWDTAP',
    },
    {
        text : text.varianceConditions,
        value: 'TMWOAVC',
    },
    {
        text : text.retaliation,
        value: 'MERAEPRUCL',
    },
];